// Events for Segment tracking

// Page Viewed -	include all page properties, locale, and country
export const pageViewed = prevLocation => {
  window.analytics &&
    window.analytics.page('Page Viewed', {
      // country: getCountryName(),
      locale: getFirstBrowserLanguage(),
      referrer: prevLocation && prevLocation.href || document && document.referrer,
    })
}

// Determines browser language
// https://github.com/angular-translate/angular-translate/blob/master/src/service/translate.js#L93
// https://stackoverflow.com/questions/1043339/javascript-for-detecting-browser-language-preference
const getFirstBrowserLanguage = function() {
  const nav = window.navigator
  const browserLanguagePropertyKeys = [
    'language',
    'browserLanguage',
    'systemLanguage',
    'userLanguage',
  ]
  let language

  // support for HTML 5.1 "navigator.languages"
  if (Array.isArray(nav.languages)) {
    for (let i = 0; i < nav.languages.length; i++) {
      language = nav.languages[i]
      if (language && language.length) {
        return language
      }
    }
  }

  // support for other well known properties in browsers
  for (let i = 0; i < browserLanguagePropertyKeys.length; i++) {
    language = nav[browserLanguagePropertyKeys[i]]
    if (language && language.length) {
      return language
    }
  }

  return null
}

// Recipe Shared -	service:	facebook, pinterest, twitter, email
export const recipeShared = service => {
  window.analytics &&
    window.analytics.track('Recipe Shared', {
      service,
    })
}

// Units Switched - targetUnit: standard, metric
export const unitsSwitched = targetUnit => {
  window.analytics &&
    window.analytics.track('Units Switched', {
      targetUnit,
    })
}

// Media Toggled
// - section:	prep, cooking
// - target	show, hide
export const mediaToggled = (section, target) => {
  if (section === 'Cooking Steps') section = 'cooking'
  if (section === 'Prep') section = 'prep'
  window.analytics &&
    window.analytics.track('Media Toggled', {
      section,
      target,
    })
}
